// extracted by mini-css-extract-plugin
export default {"hideTooltip":"oaa-z","fadeIn":"paa-z","delay":"qaa-z","recommendedSizeTooltip":"raa-z"};